(() => {
  const welcome = document.getElementById('BeautishopWelcome');
  const affirmation = document.getElementById('BeautishopAffirmation');
  const stylesheet = document.getElementById('BeautishopWelcomeStyles');

  if (!welcome || !affirmation) return;

  const welcomeKey = 'beautishop_welcome_seen_v1';
  const dailyKey = 'beautishop_affirmations_daily_v1';
  const lastAffirmationKey = 'beautishop_affirmation_last_v1';
  const dailyLimit = 3;
  const affirmationGap = 20000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const transitionTime = reducedMotion ? 0 : 460;
  const isSwedish = welcome.dataset.language === 'sv';
  const directionClasses = [
    'from-bottom-left',
    'from-top-left',
    'from-bottom-right',
    'from-top-right',
  ];
  let started = false;
  let dailyStarted = false;
  let welcomeTimer;
  let affirmationTimer;
  let dailyTimer;
  let remainingDirections = [];

  const affirmations = isSwedish
    ? [
        'Du är så vacker',
        'Du är unik',
        'Du strålar idag',
        'Din skönhet är alldeles unik',
        'Du förtjänar att känna dig fantastisk',
        'Glöm aldrig hur värdefull du är',
        'Du gör världen lite vackrare',
        'Du räcker mer än väl',
        'Ditt leende gör skillnad',
        'Det finns något alldeles särskilt hos dig',
        'Du är vacker precis som du är',
        'Din energi är magisk',
        'Du förtjänar allt fint',
        'Du lyser upp mer än du tror',
        'Det finns bara en som du',
        'Din stil berättar din historia',
        'Din styrka gör dig ännu vackrare',
        'Idag är din dag',
        'Du är full av möjligheter',
        'Din glädje smittar av sig',
        'Du är värd att firas',
        'Du har en fantastisk utstrålning',
        'Du inspirerar genom att vara dig själv',
        'Din självsäkerhet klär dig',
        'Du är vacker inifrån och ut',
        'Ditt ljus behövs',
        'Du gör ett bestående intryck',
        'Du förtjänar lite extra omtanke idag',
        'Var stolt över den du är',
        'Din personlighet får dig att stråla',
        'Du är modigare än du tror',
        'Du har kraften att forma din dag',
        'Din skönhet följer inga regler',
        'Du gör vardagen vackrare',
        'Du är en riktig stjärna',
        'Allt börjar med att du tror på dig själv',
        'Du har så mycket att vara stolt över',
        'Din närvaro betyder något',
        'Du är skapad för att glänsa',
        'Du förtjänar att känna dig självsäker',
        'Låt ditt vackra jag ta plats',
        'Du sprider så fin energi idag',
        'Det som gör dig unik är din superkraft',
        'Du är värd det bästa',
        'Fortsätt vara precis så underbar som du är',
        'Du är stark, vacker och unik',
        'Idag får du välja dig själv',
        'Världen behöver dig precis som du är',
        'Du har ett hjärta av guld',
        'Du är helt enkelt fantastisk',
      ]
    : [
        'You are so beautiful',
        'You are one of a kind',
        'You shine today',
        'Your beauty is uniquely yours',
        'You deserve to feel amazing',
        'Never forget how valuable you are',
        'You make the world a little more beautiful',
        'You are more than enough',
        'Your smile makes a difference',
        'There is something truly special about you',
        'You are beautiful just as you are',
        'Your energy is magical',
        'You deserve all things beautiful',
        'You shine brighter than you realize',
        'There is only one you',
        'Your style tells your story',
        'You carry your beauty with strength',
        'Today is your day',
        'You are full of possibilities',
        'Your joy is contagious',
        'You deserve to be celebrated',
        'You have an amazing presence',
        'You inspire by being yourself',
        'Confidence looks beautiful on you',
        'You are beautiful inside and out',
        'Your light is needed',
        'You leave a lasting impression',
        'You deserve a little extra care today',
        'Be proud of who you are',
        'Your personality makes you shine',
        'You are braver than you think',
        'You have the power to shape your day',
        'Your beauty follows no rules',
        'You make every day more beautiful',
        'You are a true star',
        'Everything begins when you believe in yourself',
        'You have so much to be proud of',
        'Your presence matters',
        'You were made to shine',
        'You deserve to feel confident',
        'Let your beautiful self take up space',
        'You are today’s brightest energy',
        'Your uniqueness is your superpower',
        'You deserve the very best',
        'Keep being wonderfully you',
        'You are strong, beautiful, and unique',
        'Today, choose yourself',
        'The world needs exactly who you are',
        'You have a heart of gold',
        'You are simply amazing',
      ];

  const storageAvailable = () => {
    try {
      const testKey = 'beautishop_storage_test';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  const localStorageAvailable = storageAvailable();

  const getDateKey = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  };

  const getDailyState = () => {
    const emptyState = { date: getDateKey(), count: 0, used: [] };

    try {
      const savedState = JSON.parse(window.localStorage.getItem(dailyKey));

      if (!savedState || savedState.date !== emptyState.date) return emptyState;

      return {
        date: emptyState.date,
        count: Math.min(dailyLimit, Math.max(0, Number(savedState.count) || 0)),
        used: Array.isArray(savedState.used)
          ? savedState.used.filter(
              (index) => Number.isInteger(index) && index >= 0 && index < affirmations.length,
            )
          : [],
      };
    } catch (error) {
      return emptyState;
    }
  };

  const saveDailyState = (state) => {
    window.localStorage.setItem(dailyKey, JSON.stringify(state));
  };

  const chooseAffirmation = (used) => {
    const lastIndex = Number(window.localStorage.getItem(lastAffirmationKey));
    const available = affirmations
      .map((message, index) => ({ message, index }))
      .filter(({ index }) => !used.includes(index) && index !== lastIndex);

    const pool = available.length
      ? available
      : affirmations.map((message, index) => ({ message, index }));

    return pool[Math.floor(Math.random() * pool.length)];
  };

  const chooseDirection = () => {
    if (!remainingDirections.length) {
      remainingDirections = [...directionClasses];

      for (let index = remainingDirections.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [remainingDirections[index], remainingDirections[randomIndex]] = [
          remainingDirections[randomIndex],
          remainingDirections[index],
        ];
      }
    }

    return remainingDirections.pop();
  };

  const createHearts = () => {
    const field = welcome.querySelector('[data-beautishop-hearts]');
    if (!field || field.childElementCount || reducedMotion) return;

    const fragment = document.createDocumentFragment();

    for (let index = 0; index < 24; index += 1) {
      const heart = document.createElement('span');
      heart.className = 'beautishop-welcome__heart';
      heart.textContent = '♥︎';
      heart.setAttribute('aria-hidden', 'true');
      heart.style.setProperty('--heart-left', Math.round(Math.random() * 100) + '%');
      heart.style.setProperty('--heart-size', (1.8 + Math.random() * 3.2).toFixed(1) + 'rem');
      heart.style.setProperty('--heart-opacity', (0.2 + Math.random() * 0.38).toFixed(2));
      heart.style.setProperty('--heart-duration', (5.5 + Math.random() * 4).toFixed(1) + 's');
      heart.style.setProperty('--heart-delay', (-Math.random() * 7).toFixed(1) + 's');
      heart.style.setProperty('--heart-drift', (-45 + Math.random() * 90).toFixed(0) + 'px');
      fragment.appendChild(heart);
    }

    field.appendChild(fragment);
  };

  const closeAffirmation = () => {
    if (affirmation.hidden) return;

    window.clearTimeout(affirmationTimer);
    affirmation.classList.remove('is-visible');

    window.setTimeout(() => {
      affirmation.hidden = true;
    }, transitionTime);
  };

  const showAffirmation = () => {
    const state = getDailyState();
    const text = affirmation.querySelector('[data-beautishop-affirmation-text]');

    if (state.count >= dailyLimit || !text) return false;

    const selected = chooseAffirmation(state.used);
    state.count += 1;
    state.used.push(selected.index);
    saveDailyState(state);
    window.localStorage.setItem(lastAffirmationKey, String(selected.index));

    window.clearTimeout(affirmationTimer);
    affirmation.classList.remove('is-visible', ...directionClasses);
    affirmation.classList.add(chooseDirection());
    affirmation.hidden = false;
    text.textContent = selected.message;

    window.requestAnimationFrame(() => {
      affirmation.classList.add('is-visible');
    });

    affirmationTimer = window.setTimeout(closeAffirmation, 8800);
    return true;
  };

  const scheduleDailyAffirmations = (initialDelay) => {
    if (dailyStarted) return;
    dailyStarted = true;

    if (getDailyState().count >= dailyLimit) {
      affirmation.remove();
      return;
    }

    const showNext = () => {
      if (!showAffirmation()) return;

      if (getDailyState().count < dailyLimit) {
        dailyTimer = window.setTimeout(showNext, affirmationGap);
      }
    };

    dailyTimer = window.setTimeout(showNext, initialDelay);
  };

  const closeWelcome = () => {
    if (welcome.hidden || welcome.classList.contains('is-leaving')) return;

    window.clearTimeout(welcomeTimer);
    welcome.classList.add('is-leaving');
    welcome.classList.remove('is-visible');

    window.setTimeout(() => {
      welcome.hidden = true;
      welcome.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('beautishop-welcome-open');
      welcome.remove();
      scheduleDailyAffirmations(3000);
    }, transitionTime);
  };

  const showWelcome = () => {
    window.localStorage.setItem(welcomeKey, '1');
    createHearts();

    welcome.hidden = false;
    welcome.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('beautishop-welcome-open');

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        welcome.classList.add('is-visible');
        welcome.querySelector('.beautishop-welcome__close')?.focus({ preventScroll: true });
      });
    });

    welcome.querySelectorAll('[data-beautishop-welcome-close]').forEach((button) => {
      button.addEventListener('click', closeWelcome, { once: true });
    });

    welcome.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeWelcome();
        return;
      }

      if (event.key !== 'Tab') return;

      const buttons = Array.from(welcome.querySelectorAll('button:not([disabled])'));
      const firstButton = buttons[0];
      const lastButton = buttons[buttons.length - 1];

      if (event.shiftKey && document.activeElement === firstButton) {
        event.preventDefault();
        lastButton.focus();
      } else if (!event.shiftKey && document.activeElement === lastButton) {
        event.preventDefault();
        firstButton.focus();
      }
    });

    welcomeTimer = window.setTimeout(closeWelcome, 3600);
  };

  const start = () => {
    if (started) return;
    started = true;

    if (!localStorageAvailable) {
      welcome.remove();
      affirmation.remove();
      return;
    }

    if (window.localStorage.getItem(welcomeKey) !== '1') {
      showWelcome();
    } else {
      welcome.remove();
      scheduleDailyAffirmations(1500);
    }
  };

  if (!stylesheet) {
    welcome.remove();
    affirmation.remove();
  } else if (stylesheet.media === 'all') {
    start();
  } else {
    stylesheet.addEventListener('load', start, { once: true });
    stylesheet.addEventListener(
      'error',
      () => {
        welcome.remove();
        affirmation.remove();
      },
      { once: true },
    );
  }
})();
